import React from 'react'
import Liberyus from '../../components/general/liberyus'
import ReferencesBanner from './references-banner'
import { Col, Row } from 'reactstrap'
import ref2 from '../../assets/images/liberyus-bursa.svg'
import ref3 from '../../assets/images/liberyus-burulas.svg'
import ref4 from '../../assets/images/liberyus-mapa.svg'
import ref5 from '../../assets/images/liberyus-ustagrup.svg'
import ref7 from '../../assets/images/liberyus-ulastirma.svg'
import ref8 from '../../assets/images/liberyus-yelken.svg'
import ref9 from '../../assets/images/liberyus-sanliurfa.svg'
import ref10 from '../../assets/images/liberyus-turgut.svg'
import ref11 from '../../assets/images/liberyus-oniz.svg'
import ref12 from '../../assets/images/liberyus-innova.svg'
import ref13 from '../../assets/images/liberyus-drayup.svg'
import ref14 from '../../assets/images/liberyus-disisleri.svg'
import ref15 from '../../assets/images/liberyus-celikler.svg'
import ref16 from '../../assets/images/liberyus-barsan.svg'
import ref17 from '../../assets/images/liberyus-alagoz.svg'




const ReferencesPage = () => {
    return (
        <Liberyus>
            <div className='references-page'>
                <ReferencesBanner />
                <Row className='reference-items'>
                    <Col xs={12} sm={6} md={4} lg={4} xl={3} xxl={3} className='mb-4 d-flex justify-content-center'><div className='item'><img src={ref2} alt='' /></div></Col>
                    <Col xs={12} sm={6} md={4} lg={4} xl={3} xxl={3} className='mb-4 d-flex justify-content-center'><div className='item'><img src={ref3} alt='' /></div></Col>
                    <Col xs={12} sm={6} md={4} lg={4} xl={3} xxl={3} className='mb-4 d-flex justify-content-center'><div className='item'><img src={ref4} alt='' /></div></Col>
                    <Col xs={12} sm={6} md={4} lg={4} xl={3} xxl={3} className='mb-4 d-flex justify-content-center'><div className='item'><img src={ref5} alt='' /></div></Col>
                    <Col xs={12} sm={6} md={4} lg={4} xl={3} xxl={3} className='mb-4 d-flex justify-content-center'><div className='item'><img src={ref7} alt='' /></div></Col>
                    <Col xs={12} sm={6} md={4} lg={4} xl={3} xxl={3} className='mb-4 d-flex justify-content-center'><div className='item'><img src={ref8} alt='' /></div></Col>
                    <Col xs={12} sm={6} md={4} lg={4} xl={3} xxl={3} className='mb-4 d-flex justify-content-center'><div className='item'><img src={ref9} alt='' /></div></Col>
                    <Col xs={12} sm={6} md={4} lg={4} xl={3} xxl={3} className='mb-4 d-flex justify-content-center'><div className='item'><img src={ref10} alt='' /></div></Col>
                    <Col xs={12} sm={6} md={4} lg={4} xl={3} xxl={3} className='mb-4 d-flex justify-content-center'><div className='item'><img src={ref11} alt='' /></div></Col>
                    <Col xs={12} sm={6} md={4} lg={4} xl={3} xxl={3} className='mb-4 d-flex justify-content-center'><div className='item'><img src={ref12} alt='' /></div></Col>
                    <Col xs={12} sm={6} md={4} lg={4} xl={3} xxl={3} className='mb-4 d-flex justify-content-center'><div className='item'><img src={ref13} alt='' /></div></Col>
                    <Col xs={12} sm={6} md={4} lg={4} xl={3} xxl={3} className='mb-4 d-flex justify-content-center'><div className='item'><img src={ref14} alt='' /></div></Col>
                    <Col xs={12} sm={6} md={4} lg={4} xl={3} xxl={3} className='mb-4 d-flex justify-content-center'><div className='item'><img src={ref15} alt='' /></div></Col>
                    <Col xs={12} sm={6} md={4} lg={4} xl={3} xxl={3} className='mb-4 d-flex justify-content-center'><div className='item'><img src={ref16} alt='' /></div></Col>
                    <Col xs={12} sm={6} md={4} lg={4} xl={3} xxl={3} className='mb-4 d-flex justify-content-center'><div className='item'><img src={ref17} alt='' /></div></Col>
                </Row>
            </div>
        </Liberyus>
    )
}

export default ReferencesPage
